import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { PLANES, PLAN_EMPRESA, planPorClave, precioPlan, avisoLanzamiento, cuposFundador, resumenSuscripcion, linkQuieroPlan, linkCotizarEmpresa, PAGO_TARJETA_ACTIVO, iniciarPago, obtenerPagos, datosCobro, hayDatosCobro, fundadorEnPlan, promoLanzamiento, montoCobro, fmtCobro, ventasAbiertas } from '../services/membresiaService';
import PagoManualModal from './PagoManualModal';
import { useToast } from '../context/ToastContext';
import CancelarPlan from './CancelarPlan';
import { EN_TIENDA } from '../utils/tienda';
import { getMoneda } from '../services/negocioActual';

const fecha = (f) => (f ? new Date(f).toLocaleDateString('es-HN', { day: 'numeric', month: 'long', year: 'numeric' }) : '');

const ESTADO_PAGO = { aprobado: ['Pagado', '#047857'], fallido: ['Rechazado', '#B91C1C'], revision: ['En revisión', '#B45309'], pendiente: ['Pendiente', '#6B7280'], reembolsado: ['Reembolsado', '#6B7280'] };

const ESTADOS = {
  prueba: { txt: 'Prueba gratis', color: '#6D28D9', fondo: '#F5F3FF' },
  activa: { txt: 'Activo', color: '#047857', fondo: '#ECFDF5' },
  gracia: { txt: 'Por renovar', color: '#B45309', fondo: '#FFFBEB' },
  cortesia: { txt: 'Cortesía VIP', color: '#A16207', fondo: '#FEF9C3' },
  pausada: { txt: 'Pausado', color: '#B91C1C', fondo: '#FEF2F2' },
};

// "Mi plan": estado de la membresía y los 3 planes. Por ahora el pago se
// coordina por WhatsApp y Automatika activa la cuenta (pasarela: más adelante).
export default function PlanesView({ onVolver }) {
  const { negocio, suscripcion } = useAuth();
  const [ciclo, setCiclo] = useState('mensual');
  const moneda = getMoneda(); // HNL → precios en lempiras; otra → en dólares
  const r = resumenSuscripcion(suscripcion);
  const est = ESTADOS[r.estado];
  const planActual = suscripcion && planPorClave(suscripcion.plan);
  // Precio fundador (sql/148): es del plan que eligió; o todavía quedan cupos de los 25.
  const [cupos, setCupos] = useState(0);
  useEffect(() => { cuposFundador().then(setCupos); }, []);
  const yaFundador = !!suscripcion?.precio_fundador;
  const { mostrarToast } = useToast();
  const [pagando, setPagando] = useState(null); // plan que está abriendo la página de pago
  const [pagos, setPagos] = useState([]);
  const cargarPagos = () => obtenerPagos().then(setPagos).catch(() => {});
  useEffect(() => { cargarPagos(); }, []);
  // Pago manual (transferencia o PayPal, sql/128). Sin datos de cobro puestos
  // en Admin, se sigue por WhatsApp como antes.
  const [cobro, setCobro] = useState(null);
  useEffect(() => { datosCobro().then(setCobro).catch(() => {}); }, []);
  const pagoManual = hayDatosCobro(cobro);
  const [pagarManual, setPagarManual] = useState(null); // clave del plan con el modal abierto
  const ultimoManual = pagos.find((x) => x.proveedor === 'transferencia' || x.proveedor === 'paypal');
  const enRevision = ultimoManual?.estado === 'revision' ? ultimoManual : null;
  const rechazado = ultimoManual?.estado === 'fallido' && Date.now() - new Date(ultimoManual.creado_en).getTime() < 14 * 86400000 ? ultimoManual : null;

  // Abre la página de pago de Tilopay (cobro automático cada mes o cada año).
  const pagar = async (plan) => {
    setPagando(plan);
    try {
      const { url } = await iniciarPago(plan, ciclo);
      window.location.href = url;
    } catch (e) {
      mostrarToast(e.message, 'error', 7000);
      setPagando(null);
    }
  };
  const fundador = yaFundador || (cupos > 0 && !suscripcion?.fundador_perdido && suscripcion?.estado !== 'cortesia');
  const planFundador = planPorClave(suscripcion?.plan_fundador);
  const abiertas = ventasAbiertas();

  let detalle = '';
  if (r.estado === 'prueba') detalle = `Tu prueba gratis termina el ${fecha(r.hasta)} (${r.diasRestantes} días). Tienes todas las funciones del plan Pro.`;
  else if (r.estado === 'activa' || r.estado === 'gracia') detalle = `Plan ${planActual?.nombre || ''} ${suscripcion?.ciclo ? `(${suscripcion.ciclo})` : ''}. Pagado hasta el ${fecha(r.hasta)}.`;
  else if (r.estado === 'cortesia') detalle = 'Tienes el plan Pro de cortesía, sin vencimiento. ¡Gracias por ayudarnos a construir Kontrol! 💜';
  else if (r.estado === 'pausada') detalle = EN_TIENDA
    ? 'Tu cuenta está pausada: puedes ver tus datos pero no guardar cambios. No se borró nada.'
    : 'Tu cuenta está pausada: puedes ver tus datos pero no guardar cambios. Elige un plan y la reactivamos el mismo día. No se borró nada.';

  // App de Google Play / App Store: solo el estado del plan y lo que incluye.
  // Sin precios, sin botones de compra ni invitaciones a pagar (reglas de las tiendas).
  if (EN_TIENDA) {
    const incluye = (planActual || planPorClave('negocio'))?.puntos || [];
    return (
      <div className="k-page">
        <div className="k-page-head">
          <h2 className="k-page-title">💎 Mi plan</h2>
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
        {est && (
          <div className="k-card" style={{ padding: '16px', marginBottom: '16px', display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ background: est.fondo, color: est.color, fontWeight: 700, borderRadius: '999px', padding: '4px 12px', fontSize: '13px' }}>{est.txt}</span>
            <span style={{ color: '#374151', fontSize: '14px', flex: 1, minWidth: '220px' }}>{detalle}</span>
          </div>
        )}
        <div className="k-card" style={{ padding: '16px' }}>
          <b style={{ display: 'block', marginBottom: '8px' }}>{(planActual || planPorClave('negocio'))?.icono} Tu plan {(planActual || planPorClave('negocio'))?.nombre} incluye</b>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '14px', color: '#374151' }}>
            {incluye.map((x) => <li key={x} style={{ padding: '3px 0' }}>✓ {x}</li>)}
          </ul>
        </div>
        <CancelarPlan />
      </div>
    );
  }

  return (
    <div className="k-page">
      <div className="k-page-head">
        <h2 className="k-page-title">💎 Mi plan</h2>
        <button onClick={onVolver} className="k-btn-soft">← Volver</button>
      </div>

      {est && (
        <div className="k-card" style={{ padding: '16px', marginBottom: '20px', display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ background: est.fondo, color: est.color, fontWeight: 700, borderRadius: '999px', padding: '4px 12px', fontSize: '13px' }}>{est.txt}</span>
          <span style={{ color: '#374151', fontSize: '14px', flex: 1, minWidth: '220px' }}>{detalle}</span>
        </div>
      )}

      {fundador && (
        <div style={{ padding: '14px 16px', marginBottom: '18px', borderRadius: '14px', background: '#1C1830', color: '#F3F0FA', display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '24px' }}>🏅</span>
          <span style={{ flex: 1, minWidth: '220px', fontSize: '14px' }}>
            {yaFundador
              ? <><b style={{ color: '#D4AF37' }}>Tienes precio fundador{planFundador ? ` en el plan ${planFundador.nombre}` : ''}.</b> Lo conservas para siempre mientras sigas en ese plan y pagues cada mes. Si cambias de plan o dejas de pagar, pagas el precio normal.</>
              : <><b style={{ color: '#D4AF37' }}>Precio fundador: quedan {cupos} de 25 cupos.</b> Los primeros 25 negocios que paguen se quedan con este precio para siempre en el plan que elijan.</>}
          </span>
        </div>
      )}

      {!yaFundador && suscripcion?.estado !== 'cortesia' && avisoLanzamiento(moneda, ciclo) && (
        <div style={{ padding: '12px 16px', marginBottom: '18px', borderRadius: '14px', background: '#FFF7E6', border: '1px solid #F6D58E', color: '#7A4B00', fontSize: '14px' }}>
          ⏳ {avisoLanzamiento(moneda, ciclo)}
        </div>
      )}

      {!abiertas && suscripcion?.estado !== 'activa' && (
        <div style={{ padding: '12px 16px', marginBottom: '18px', borderRadius: '14px', background: '#F5F3FF', border: '1px solid #DDD6FE', color: '#4C1D95', fontSize: '14px' }}>
          🎂 <b>Kontrol abre sus ventas el domingo 13 de diciembre.</b> Ese día se reparten los cupos de precio fundador. Mientras tanto, tu prueba gratis sigue con todas las funciones.
        </div>
      )}

      {enRevision && (
        <div style={{ padding: '14px 16px', marginBottom: '18px', borderRadius: '14px', background: '#FFFBEB', color: '#92400E', fontSize: '14px' }}>
          ⏳ <b>Recibimos tu comprobante</b> del plan {planPorClave(enRevision.plan)?.nombre} ({enRevision.ciclo}) el {fecha(enRevision.creado_en)}. Lo estamos revisando; tu plan se activa en menos de 24 horas.
        </div>
      )}
      {rechazado && (
        <div style={{ padding: '14px 16px', marginBottom: '18px', borderRadius: '14px', background: '#FEF2F2', color: '#991B1B', fontSize: '14px' }}>
          ❌ <b>No pudimos confirmar tu pago</b> del {fecha(rechazado.creado_en)}{rechazado.motivo ? `: ${rechazado.motivo}` : ''}. Puedes volver a enviar el comprobante o escribirnos por WhatsApp.
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
        <div style={{ display: 'inline-flex', background: '#F3F0FA', borderRadius: '999px', padding: '4px' }}>
          {['mensual', 'anual'].map((c) => (
            <button key={c} onClick={() => setCiclo(c)}
              style={{ border: 'none', cursor: 'pointer', borderRadius: '999px', padding: '8px 18px', fontWeight: 700, fontFamily: 'inherit', fontSize: '14px',
                background: ciclo === c ? 'var(--color-primario,#6D28D9)' : 'transparent', color: ciclo === c ? '#fff' : '#4B5563' }}>
              {c === 'mensual' ? 'Mensual' : 'Anual (−20%)'}
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '14px' }}>
        {PLANES.map((p) => {
          const fundP = fundadorEnPlan(suscripcion, cupos, p.clave);
          const promo = promoLanzamiento({ fundador: fundP, ciclo, pagos });
          const pr = precioPlan(p, ciclo, moneda, fundP);
          const normal = precioPlan(p, ciclo, moneda);
          const esActual = suscripcion?.estado === 'activa' && suscripcion?.plan === p.clave;
          return (
            <div key={p.clave} className="k-card" style={{ padding: '20px', position: 'relative', border: p.recomendado ? '2px solid var(--color-primario,#6D28D9)' : undefined }}>
              {p.recomendado && (
                <span style={{ position: 'absolute', top: '-11px', left: '50%', transform: 'translateX(-50%)', background: 'var(--color-primario,#6D28D9)', color: '#fff', fontSize: '12px', fontWeight: 700, borderRadius: '999px', padding: '3px 12px' }}>Recomendado</span>
              )}
              <div style={{ fontSize: '28px' }}>{p.icono}</div>
              <h3 style={{ margin: '6px 0 2px', fontSize: '20px' }}>{p.nombre}</h3>
              {fundP && <div style={{ fontSize: '13px', color: '#9CA3AF', textDecoration: 'line-through' }}>{normal.porMes}/mes</div>}
              <div style={{ fontSize: '30px', fontWeight: 800, color: '#1C1830' }}>{pr.porMes}<span style={{ fontSize: '14px', fontWeight: 500, color: '#6B7280' }}>/mes</span></div>
              <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '12px', minHeight: '18px' }}>
                {pr.usdMes && <span style={{ display: 'block', fontWeight: 600, color: '#4B5563' }}>≈ {pr.usdMes}/mes</span>}
                {ciclo === 'anual' ? `${pr.alAnio} al año${pr.usdAnio ? ` (≈ ${pr.usdAnio})` : ''}, pagado por adelantado` : 'Se cobra cada mes'}
                {promo && <span style={{ display: 'block', fontWeight: 700, color: '#B45309' }}>🎉 Tu primer mes: {fmtCobro(montoCobro(p.clave, ciclo, moneda, false, true), moneda)} (hasta el 18-dic)</span>}
                {yaFundador && !fundP && <span style={{ display: 'block', color: '#B45309' }}>Tu precio fundador es del plan {planFundador?.nombre}: este plan va a precio normal.</span>}
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px', fontSize: '14px', color: '#374151' }}>
                {p.puntos.map((x) => <li key={x} style={{ padding: '3px 0' }}>✓ {x}</li>)}
              </ul>
              {esActual
                ? <div style={{ textAlign: 'center', fontWeight: 700, color: '#047857', padding: '10px' }}>✅ Tu plan actual</div>
                : !abiertas && suscripcion?.estado !== 'activa'
                ? <div style={{ textAlign: 'center', fontWeight: 700, color: '#6D28D9', padding: '10px', background: '#F5F3FF', borderRadius: '10px' }}>Disponible el 13 de diciembre</div>
                : PAGO_TARJETA_ACTIVO ? (
                  <>
                    <button onClick={() => pagar(p.clave)} disabled={!!pagando}
                      style={{ display: 'block', width: '100%', textAlign: 'center', background: p.recomendado ? 'var(--color-primario,#6D28D9)' : '#fff', color: p.recomendado ? '#fff' : 'var(--color-primario,#6D28D9)', border: '1px solid var(--color-primario,#6D28D9)', borderRadius: '10px', padding: '11px', fontWeight: 700, fontFamily: 'inherit', fontSize: '15px', cursor: pagando ? 'wait' : 'pointer' }}>
                      {pagando === p.clave ? 'Abriendo el pago…' : '💳 Pagar con tarjeta'}
                    </button>
                    {pagoManual ? (
                      <button onClick={() => setPagarManual(p.clave)}
                        style={{ display: 'block', width: '100%', textAlign: 'center', marginTop: '8px', fontSize: '13px', color: '#6B7280', background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', fontFamily: 'inherit' }}>
                        o paga por transferencia / PayPal
                      </button>
                    ) : (
                      <a href={linkQuieroPlan({ negocioNombre: negocio?.nombre, plan: p.clave, ciclo, moneda, fundador })} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'block', textAlign: 'center', marginTop: '8px', fontSize: '13px', color: '#6B7280' }}>
                        o paga por transferencia (WhatsApp)
                      </a>
                    )}
                  </>
                ) : pagoManual ? (
                  <button onClick={() => setPagarManual(p.clave)}
                    style={{ display: 'block', width: '100%', textAlign: 'center', background: p.recomendado ? 'var(--color-primario,#6D28D9)' : '#fff', color: p.recomendado ? '#fff' : 'var(--color-primario,#6D28D9)', border: '1px solid var(--color-primario,#6D28D9)', borderRadius: '10px', padding: '11px', fontWeight: 700, fontFamily: 'inherit', fontSize: '15px', cursor: 'pointer' }}>
                    Quiero este plan
                  </button>
                ) : (
                  <a href={linkQuieroPlan({ negocioNombre: negocio?.nombre, plan: p.clave, ciclo, moneda, fundador })} target="_blank" rel="noopener noreferrer"
                    style={{ display: 'block', textAlign: 'center', textDecoration: 'none', background: p.recomendado ? 'var(--color-primario,#6D28D9)' : '#fff', color: p.recomendado ? '#fff' : 'var(--color-primario,#6D28D9)', border: '1px solid var(--color-primario,#6D28D9)', borderRadius: '10px', padding: '11px', fontWeight: 700 }}>
                    Quiero este plan
                  </a>
                )}
            </div>
          );
        })}

        {/* Empresa: a la medida, se cotiza por WhatsApp */}
        <div className="k-card" style={{ padding: '20px', position: 'relative', background: '#1C1830', color: '#fff' }}>
          <span style={{ position: 'absolute', top: '-11px', left: '50%', transform: 'translateX(-50%)', background: '#D4AF37', color: '#1C1830', fontSize: '12px', fontWeight: 700, borderRadius: '999px', padding: '3px 12px', whiteSpace: 'nowrap' }}>Próximamente</span>
          <div style={{ fontSize: '28px' }}>{PLAN_EMPRESA.icono}</div>
          <h3 style={{ margin: '6px 0 2px', fontSize: '20px', color: '#fff' }}>{PLAN_EMPRESA.nombre}</h3>
          <div style={{ fontSize: '26px', fontWeight: 800 }}>A la medida</div>
          <div style={{ fontSize: '12px', color: '#C4B5FD', marginBottom: '12px' }}>Para negocios grandes y con varias sucursales</div>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px', fontSize: '14px', color: '#E5E7EB' }}>
            {PLAN_EMPRESA.puntos.map((x) => <li key={x} style={{ padding: '3px 0' }}>✓ {x}</li>)}
          </ul>
          <a href={linkCotizarEmpresa(negocio?.nombre)} target="_blank" rel="noopener noreferrer"
            style={{ display: 'block', textAlign: 'center', textDecoration: 'none', background: '#D4AF37', color: '#1C1830', borderRadius: '10px', padding: '11px', fontWeight: 700 }}>
            Cotizar
          </a>
        </div>
      </div>

      <p style={{ textAlign: 'center', color: '#6B7280', fontSize: '13px', marginTop: '18px' }}>
        Todos los planes incluyen productos, servicios, cotizaciones, agenda, órdenes y catálogo público sin límites.{' '}
        {PAGO_TARJETA_ACTIVO
          ? 'Con tarjeta, tu plan se activa al momento y se renueva solo. Puedes cancelar cuando quieras.'
          : pagoManual
            ? 'Pagas por transferencia o PayPal, subes tu comprobante y activamos tu plan el mismo día.'
            : 'Al tocar "Quiero este plan" nos escribes por WhatsApp y activamos tu cuenta el mismo día.'}
      </p>

      {pagos.length > 0 && (
        <div className="k-card" style={{ padding: '16px', marginTop: '18px' }}>
          <b style={{ display: 'block', marginBottom: '8px' }}>🧾 Tus pagos</b>
          {pagos.map((x) => (
            <div key={x.id} style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', padding: '8px 0', borderTop: '1px solid #F3F0FA', fontSize: '14px', flexWrap: 'wrap' }}>
              <span>{new Date(x.creado_en).toLocaleDateString('es-HN', { day: 'numeric', month: 'short', year: 'numeric' })} · {planPorClave(x.plan)?.nombre || '—'} {x.ciclo || ''}</span>
              <span><b>{x.moneda === 'HNL' ? 'L' : '$'} {Number(x.monto).toLocaleString('es-HN')}</b> <span style={{ color: (ESTADO_PAGO[x.estado] || [])[1], fontWeight: 600, marginLeft: '6px' }}>{(ESTADO_PAGO[x.estado] || [x.estado])[0]}</span></span>
              {x.estado === 'fallido' && x.motivo && <span style={{ width: '100%', fontSize: '12px', color: '#991B1B' }}>{x.motivo}</span>}
            </div>
          ))}
        </div>
      )}

      <CancelarPlan />

      {pagarManual && (
        <PagoManualModal plan={pagarManual} ciclo={ciclo} moneda={moneda} fundador={fundadorEnPlan(suscripcion, cupos, pagarManual)}
          promo={promoLanzamiento({ fundador: fundadorEnPlan(suscripcion, cupos, pagarManual), ciclo, pagos })} datos={cobro}
          negocioNombre={negocio?.nombre} onCerrar={() => setPagarManual(null)} onEnviado={cargarPagos} />
      )}
    </div>
  );
}
